import NoticeDetailType from './NoticeDetailType'
export default NoticeDetailType;


// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/NoticeDetailType/index.js